function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M65.896 38.73a1.53 1.53 0 010 2.166L44.458 62.333a1.53 1.53 0 01-2.166 0l-9.188-9.187a1.532 1.532 0 012.167-2.167l8.104 8.104L63.729 38.73a1.531 1.531 0 012.167 0zM87.78 49A38.281 38.281 0 1149.5 10.719 38.323 38.323 0 0187.781 49zm-3.062 0A35.219 35.219 0 1049.5 84.219 35.257 35.257 0 0084.719 49z",
  fill: "currentColor"
});

function SvgCheckCircleThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCheckCircleThin;